import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";

import { sectionStyles } from "../styles";

interface ILineChartSectionProps {
  title: string;
  aiSummary: string | undefined;
  chartImage: string | undefined;
  noDataLabel: string;
}

export const LineChartSection: React.FunctionComponent<
  ILineChartSectionProps
> = ({ title, aiSummary, chartImage, noDataLabel }) => {
  return (
    <View style={sectionStyles.container}>
      <Text style={sectionStyles.title}>{title}</Text>
      <View style={sectionStyles.divider} />
      {chartImage ? (
        <View style={sectionStyles.chartImageContainer}>
          <Image src={chartImage} style={sectionStyles.chartImage} />
        </View>
      ) : (
        <Text style={sectionStyles.noData}>{noDataLabel}</Text>
      )}
      {aiSummary && (
        <View style={sectionStyles.summaryTextContainer}>
          <Text style={sectionStyles.summaryText}>{aiSummary}</Text>
        </View>
      )}
    </View>
  );
};
